/**
 * @generated SignedSource<<98fd7091c03d4a00d54bad6d1974819b>>
 * @relayHash 7cbfb8b5dd0b6c2b9e305a2b886cfae9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8d54302382af1a5080021938756ad8cae63c6d6ed081105993e357694be28739

import type { ConcreteRequest, Query } from 'relay-runtime';
export type MoreProjectsQuery$variables = {
  cloudId: string;
};
export type MoreProjectsQuery$data = {
  readonly jira_projectsSidebarMenu: {
    readonly moreFavourites: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar: {
            readonly large: string | null | undefined;
          } | null | undefined;
          readonly defaultNavigationItem: {
            readonly url?: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly projectKey: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly moreRecents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar: {
            readonly large: string | null | undefined;
          } | null | undefined;
          readonly defaultNavigationItem: {
            readonly url?: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly projectKey: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type MoreProjectsQuery = {
  response: MoreProjectsQuery$data;
  variables: MoreProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "large"
    }
  ]
},
v5 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
},
v7 = [
  {
    "concreteType": "JiraProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v8 = [
  {
    "concreteType": "JiraProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MoreProjectsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreFavourites",
            "plural": false,
            "selections": (v7/*: any*/)
          },
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreRecents",
            "plural": false,
            "selections": (v7/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoreProjectsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreFavourites",
            "plural": false,
            "selections": (v8/*: any*/)
          },
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreRecents",
            "plural": false,
            "selections": (v8/*: any*/)
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "8d54302382af1a5080021938756ad8cae63c6d6ed081105993e357694be28739",
    "metadata": {},
    "name": "MoreProjectsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "30809ab6925897e3757e7943cb2d0acf";

export default node;
